var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("textarea", {
    style: _vm.computedStyles,
    attrs: { rows: "1" },
    domProps: { value: _vm.value },
    on: {
      focus: _vm.resize,
      input: function ($event) {
        _vm.resize(), _vm.$emit("input", $event)
      },
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _vm.onEnterPressed.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }